import { Base64 } from 'js-base64';
import config from '../../../configuration/config';

export default function ContactTile({ icon, name, value, type }) {
    const isLink = type != null;
    const href = isLink ? type + value : null;

    const getIconFromType = (name) => {
        const lowerName = name?.toLowerCase() || '';
        if (lowerName.includes('email') || lowerName.includes('بريد')) return '/assets/icons/contact/email.svg';
        if (lowerName.includes('phone') || lowerName.includes('mobile') || lowerName.includes('هاتف') || lowerName.includes('جوال')) return '/assets/icons/contact/phone.svg';
        if (lowerName.includes('whatsapp') || lowerName.includes('واتس')) return '/assets/icons/social/whatsup.svg';
        if (lowerName.includes('location') || lowerName.includes('address') || lowerName.includes('موقع') || lowerName.includes('عنوان')) return '/assets/icons/contact/location.svg';
        if (lowerName.includes('fax') || lowerName.includes('فاكس')) return '/assets/icons/contact/fax.svg';
        if (lowerName.includes('office')) return '/assets/icons/contact/office.svg';
        return '/assets/icons/info.svg';
    };

    const displayIcon = icon && icon.includes('.')
        ? (Base64.isValid(icon) === 1 ? "data:image/png;base64," : config.mainURL) + "" + icon
        : getIconFromType(name);

    return (
        <a
            target="_blank"
            rel="noreferrer"
            href={href}
            className="contact-tile group flex items-center p-4 rounded-xl bg-white dark:bg-surface border border-gray-100 dark:border-white/5 hover:border-g hover:shadow-md transition-all duration-300"
        >
            <div className="contact-tile-icon w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-full bg-g/5 group-hover:bg-g/10 transition-colors">
                <img
                    src={displayIcon}
                    onError={(e) => { e.target.src = getIconFromType(name); }}
                    className="w-6 h-6 object-contain"
                    alt=""
                />
            </div>
            <div className="contact-tile-meta mx-4">
                <span className="contact-tile-name block text-14 text-t3 mb-1">{name}</span>
                <span className="contact-tile-value block text-16 font-bold text-t1 overflow-hidden overflow-ellipsis">
                    {value?.includes("http") ? (localStorage.getItem('i18nextLng') === 'ar' ? 'زيارة الرابط' : 'Visit Link') : value}
                </span>
            </div>
        </a>
    );
}